import { SelectOption } from '@tryhackme/thm-ui-components';
export const paginationOptions: SelectOption[] = [{
  id: '1',
  label: '10',
  value: '10'
}, {
  id: '2',
  label: '20',
  value: '20'
}];